module.exports = __webpack_public_path__ + "static/media/cloud-rainbow.b1e769cb.svg";